import { render, staticRenderFns } from "./CanvasDesk.vue?vue&type=template&id=5663d1a1&scoped=true&"
import script from "./CanvasDesk.vue?vue&type=script&lang=js&"
export * from "./CanvasDesk.vue?vue&type=script&lang=js&"
import style0 from "./CanvasDesk.vue?vue&type=style&index=0&id=5663d1a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663d1a1",
  null
  
)

export default component.exports